// Bump CACHE_BUST_TOKEN whenever cached app icons/logos must be re-fetched
// after a deploy. Appended as `?t=<token>` so browsers treat the new value
// as a distinct resource.
export const CACHE_BUST_TOKEN = '2';

export function withCacheBust(url: string | null | undefined): string {
  if (!url) {
    return url ?? '';
  }
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}t=${CACHE_BUST_TOKEN}`;
}
